import type { RouteRecordNameGeneric } from 'vue-router'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  if (to.meta.public || to.path.startsWith('/auth/')) {
    return
  }

  const preRenderedRoutes: RouteRecordNameGeneric[] = ['index', 'welcome']
  if (import.meta.prerender && preRenderedRoutes.includes(to.name)) {
    return
  }

  const router = useRouter()
  const routeIsValid = to.name && router.hasRoute(to.name)
  if (!routeIsValid) {
    return
  }

  const getValidFullPath = (): string | null =>
    !preRenderedRoutes.includes(to.name) ? to.fullPath : null

  const requestedPage = useCookie('requested_page')
  const { fetch, loggedIn, ready } = useUserSession()

  if (!ready.value || !loggedIn.value) {
    await fetch()
  }

  if (!loggedIn.value) {
    requestedPage.value ??= getValidFullPath()
    return navigateTo('/welcome')
  }

  if (requestedPage.value && to.fullPath !== requestedPage.value) {
    const goTo = `${requestedPage.value}`
    requestedPage.value = null
    return navigateTo(goTo, { replace: true })
  }

  requestedPage.value = null
})
